import React from 'react'
import PropTypes from 'prop-types'

const Separator = ({ turns, style }) => (
  <div
    className="flex"
    style={{
      position: 'absolute',
      height: '100%',
      transform: `rotate(${turns}turn)`,
    }}
  >
    <div className="flex" style={style} />
  </div>
)

export const RadialProgressSeparator = ({ count, style }) => {
  const turns = 1 / count
  const separators = []

  // eslint-disable-next-line no-plusplus
  for (let i = 1; i <= count; i++) {
    separators.push(<Separator key={i} turns={i * turns} style={style} />)
  }

  return separators
}

RadialProgressSeparator.propTypes = { count: PropTypes.number, style: PropTypes.object }

RadialProgressSeparator.defaultProps = {
  count: 4,
  style: { background: '#fff', width: '3px', height: '6%' },
}
